module.exports = __webpack_public_path__ + "img/2.b0045210.png";